import styled from 'styled-components'
import { Link } from 'react-router-dom'
import logo from '../imgs/logo/logook.svg'
//
export default function Home() {
  return (
    <Main>
      <Container>
        <a
          href="https://www.comcompromisso.com.br"
          target="_blank"
          rel="noreferrer"
        >
          <img src={logo} alt="The Cosmic"></img>
        </a>
        <Botoes>
          <Link to={'/instrucao-calibragem'}>
            <button>Tenho um anel para medir</button>
          </Link>

          <Link to={'/instrucao-sem-anel'}>
            <Botao2>Não tenho um anel</Botao2>
          </Link>
        </Botoes>
      </Container>
      <Dev>
        <a href="https://linktr.ee/israel.felipe" target="blank">
          <h1>Desenvolvido com amor por: Anellus 🖤</h1>
        </a>
      </Dev>
    </Main>
  )
}

const Main = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #66b0b4;
`

const Container = styled.div`
  width: 80vw;
  height: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (min-width: 500px) {
    height: 70vh;
  }

  @media (min-width: 1300px) {
    flex-direction: inherit;
    height: 70vh;
  }

  img {
    width: 55vw;
    max-width: 450px;
    max-height: 40vh;
    margin-bottom: 17vh;
    margin-top: -4vh;
    cursor: pointer;

    @media (min-width: 1300px) {
      max-width: 400px;
      margin-bottom: 0vh;
      margin-right: 3.5vw;
      margin-left: 3vw;
    }
  }
`

const Botoes = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;

  @media (min-width: 1300px) {
    height: 100%;
    width: 100%;
    gap: 25px;
  }

  button {
    width: 80vw;
    height: auto;
    padding: 20px;
    background-color: #f8fafa;
    background-size: cover;
    color: #642c1c;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    border-radius: 99px;
    border: 3px solid #d9bf9c;
    cursor: pointer;

    @media (min-width: 1300px) {
      margin: 0 5%;
      width: 90%;
      height: 17vh;
      font-size: 2vw;
    }
  }
`

const Botao2 = styled.button`
  background-image: #fffff2 !important;
  background-size: cover;
`

const Dev = styled.h1`
  position: fixed;
  bottom: 0vh;
  width: 100%;
  height: 5vh;
  display: flex;
  justify-content: center;
  align-items: center;

  h1 {
    color: #642c1c;
    cursor: pointer;
    opacity: 0.6;
    text-align: center;

    @media (min-width: 1300px) {
      font-size: 20px;
    }
  }

  h2 {
    margin-bottom: 15px;
    color: #220713;
    opacity: 0.4;
    text-align: center;

    @media (min-width: 1300px) {
      font-size: 20px;
    }
  }
`
